import axios from "axios";

const AUDIT_SESSION_KEY = "eidsa_audit_session_id";
const AUDIT_URL = `${process.env.VUE_APP_Service_URL}/management/audit/screenaccesslog`;

type RouteValues = Record<string, unknown>;

type PageVisit = {
  name?: string | symbol | null;
  path: string;
  params: RouteValues;
  query: RouteValues;
  referrerRoute: string;
  userRole: string;
};

function createSessionId(): string {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (character) => {
    const random = Math.floor(Math.random() * 16);
    const value = character === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}

function getSessionId(): string {
  const existingSessionId = sessionStorage.getItem(AUDIT_SESSION_KEY);
  if (existingSessionId) return existingSessionId;

  const sessionId = createSessionId();
  sessionStorage.setItem(AUDIT_SESSION_KEY, sessionId);
  return sessionId;
}

function stringifyRouteValues(values: RouteValues): Record<string, string> {
  return Object.keys(values).reduce((result, key) => {
    const value = values[key];
    result[key] = Array.isArray(value)
      ? value.map(String).join(",")
      : value == null
        ? ""
        : String(value);
    return result;
  }, {} as Record<string, string>);
}

function getDeviceType(): string {
  if (window.innerWidth < 768) return "Mobile";
  if (window.innerWidth < 1024) return "Tablet";
  return "Desktop";
}

export function clearAuditSession(): void {
  sessionStorage.removeItem(AUDIT_SESSION_KEY);
}

export async function trackPageVisit(page: PageVisit, token: string): Promise<void> {
  try {
    const screenId = page.name ? String(page.name) : page.path;
    const routeParams = stringifyRouteValues(page.params);
    const entityKey = Object.keys(routeParams).find((key) => routeParams[key] !== "");

    await axios.post(AUDIT_URL, {
      userRole: page.userRole || "Unknown",
      sessionId: getSessionId(),
      screenId,
      screenName: screenId,
      route: page.path,
      routeParams,
      queryParams: stringifyRouteValues(page.query),
      action: "SCREEN_ACCESS",
      relatedEntity: entityKey
        ? { type: entityKey, id: routeParams[entityKey] }
        : { type: "screen", id: screenId },
      referrerRoute: page.referrerRoute,
      deviceType: getDeviceType(),
      service: "EIDSA WebApp",
      environment: "staging",
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    // Audit logging must never block page navigation.
    console.warn("Screen access audit failed", error);
  }
}
